
import Vue from "vue";
export default Vue.extend({
  name: "App",
  components: {
    NotificationBar: () => import("./components/NotificationBar/NotificationBar.vue"),
    LoadingBar: () => import("./components/LoadingBar/LoadingBar.vue"),
  },
});
